/**
 * View configuration for the Admin module
 */

export const getAdminViews = (userCount, partnerCount) => [
  {
    id: "users",
    name: "Users",
    icon: "Users",
    description: "Manage system users",
    count: userCount,
    whoCanAccess: ["ADMIN", "MANAGER"],
  },
  {
    id: "partners",
    name: "Partners",
    icon: "Briefcase",
    description: "Manage Partners",
    count: partnerCount,
    whoCanAccess: ["ADMIN"],
  },
];
